import React from 'react';
import cx from 'classnames';

export default ({ className, ...rest }) => (
  <span className={cx('color-fastmodel-red', className)} { ...rest }>*</span>
);


// WEBPACK FOOTER //
// ./src/js/components/layout/RequiredIndicator.jsx